// eslint-disable-next-line import/prefer-default-export
export const YusaOvernightCampProgramAndPropertySelector = ({
  yusaOvernightCampProgramAndPropertyData: {
    YusaOvernightCampProgramAndPropertyList
  }
}) => YusaOvernightCampProgramAndPropertyList;
